import { Group, Text, Button, Flex, Box, Skeleton, Loader } from "@mantine/core"
import { useId } from "@mantine/hooks";
import { useTranslation } from "react-i18next";

// status (optional): 'loading' | 'error' | 'empty' — AD-105 async suggestions.
export const AITextSuggestions = ({ aiSuggestions = [], onClickSuggestion, status }) => {

    const { t } = useTranslation();
    const uuid = useId();
    const hasChips = aiSuggestions?.length > 0;

    return (
        <Flex>
            <Box pos="relative" pr="sm">
            <Text fw={500} fz={14} c="gray" w="max-content">{t('adBuilder.aiSuggestions')}</Text>
            </Box>
            {(!hasChips && status === 'loading') ? (
                <Group gap={6} align="center">
                    <Loader size={14} color="gray" />
                    <Skeleton h={22} w={72} radius="md" />
                    <Skeleton h={22} w={96} radius="md" />
                    <Skeleton h={22} w={64} radius="md" />
                </Group>
            ) : (!hasChips && status === 'error') ? (
                <Text fz={12} c="dimmed" fs="italic">{t('ai.unavailable')}</Text>
            ) : (!hasChips && status === 'empty') ? (
                <Text fz={12} c="dimmed" fs="italic">{t('ai.noSuggestions')}</Text>
            ) : (
            <Group gap={4}>
                { 
                    aiSuggestions?.map((item, index) => (
                        <Button key={uuid + '_' + index} variant="default" size="compact-xs" radius="md" onClick={() => onClickSuggestion(item)}>{item}</Button>
                    ))
                }
            </Group>
            )}
        </Flex>
    )
}